import _ from "lodash";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import { maskContactInfo, isMaskContactInfo, maskVisitorDisplayNameIfNeeded } from "../../../utils/utils";

function maskActivityVisitorName(val, activity) {
    return maskVisitorDisplayNameIfNeeded(val, _.get(activity, "refVisitor"));
}

function getActorName(activity) {
    if (activity.actor === "user") {
        return _.get(activity, "actorUser.name");
    } else if (activity.actor === "visitor") {
        return maskActivityVisitorName(_.get(activity, "refVisitor.fullname"), activity);
    } else if (activity.actor === "chatbot") {
        return "Chatbot";
    } else if (activity.actor === "system") {
        return "System";
    }
}

function getActivityVisitor(activity) {
    const ref = _.get(activity, "refVisitor");
    return _.isArray(ref) && ref.length > 0 ? ref[0] : ref;
}

function getActivityVisitorName(activity, that) {
    const v = getActivityVisitor(activity);
    return (v && (v.fullname || v.email)) || (that && that.$t("auto.activityUnknownVisitor"));
}

function getActivityTagNames(activity, that) {
    const payload = _.get(activity, "payload", {});
    if (payload.tagName) return payload.tagName;
    if (_.isArray(payload.tagNames) && payload.tagNames.length > 0) return payload.tagNames.join(", ");
    const tags = _.get(activity, "refTags", []);
    const names = tags.map((t) => (_.isObject(t) && t.name ? t.name : t)).join(", ");
    return names || (that && that.$t("auto.activityTagsLabel"));
}

function getContactBatchActionText(action) {
    const actionTexts = {
        "add-tags": "etiket ekleme",
        "add-preferred-department": "tercih edilen departman ekleme",
        "add-preferred-agents": "tercih edilen agent ekleme",
        "set-owner": "sahip atama",
        "set-vip": "VIP durumu güncelleme",
        "add-contact-property": "kişi özelliği ekleme",
        "add-note": "not ekleme",
        "mark-as-answered": "cevaplanmış olarak işaretleme",
        "mark-as-read": "okunmuş olarak işaretleme",
    };
    return actionTexts[action] || "güncelleme";
}

const settingPageChange = (name, that) => {
    that.$router.push(`/settings/${name}`);
    SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.SETTINGS_PAGE_CHANGED, {
        name,
    });
};

const ActivityTypes = {
    BLOCK_VISITOR: {
        id: "blocked",
        icon: "assignment_ind",
        message: (activity, that) =>
            that.$t("notification.visitorBlocked", {
                visitor: maskActivityVisitorName(that.$_.get(activity, "refVisitor.fullname"), activity),
                agent: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },
    UNBLOCK_VISITOR: {
        id: "unblocked",
        icon: "block",
        message: (activity, that) =>
            that.$t("notification.visitorUnblocked", {
                visitor: maskActivityVisitorName(that.$_.get(activity, "payload.fullname"), activity),
                agent: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },
    CHAT_OPENED: {
        id: "chat-opened",
        icon: "open_in_new",
        message: (activity) => {
            if (activity.actor === "visitor") {
                return `${maskActivityVisitorName(_.get(activity, "refVisitor.fullname"), activity)} started ${_.get(activity, "payload.ref")} chat`;
            } else if (activity.actor === "user") {
                return `${_.get(activity, "payload.ref")} Chat started with ${maskActivityVisitorName(_.get(
                    activity,
                    "refVisitor.fullname"
                ), activity)} by ${_.get(activity, "actorUser.name")}`;
            } else {
                return "";
            }
        },
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },

    CHAT_CLOSED: {
        id: "chat-closed",
        icon: "closed_caption_disabled",
        message: (activity, that) =>
            // ${getActorName(activity)}
            that.$t("notification.chatClosed", {
                visitor: maskActivityVisitorName(that.$_.get(activity, "refVisitor.fullname"), activity),
                agent: getActorName(activity),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },
    //bu kısma geri dönülecek uı da gösterim komponenti mevcut değil
    CHAT_RATING: {
        id: "chat-rating",
        icon: "reviews",
        message: (activity) => `Chata puan verildi`,
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },
    CHAT_ASSIGNED_TO_USER: {
        id: "chat-assigned-to-user",
        icon: "event_seat",
        message: (activity, that) =>
            that.$t("notification.chatAssigned", {
                visitor: maskActivityVisitorName(that.$_.get(activity, "payload.fullname"), activity),
                agent: that.$_.get(activity, "payload.joinedUserName"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },
    CHAT_FORWARDED_TO_USER: {
        id: "chat-forwarded-to-user",
        icon: "mark_chat_read",
        // getActorName(activity)
        message: (activity, that) =>
            that.$t("notification.chatForwarded", {
                visitor: maskActivityVisitorName(that.$_.get(activity, "payload.fullname"), activity),
                agent: that.$_.get(activity, "payload.joinedUserName"),
                user: getActorName(activity),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },

    USER_JOINED_TO_CHAT: {
        id: "user-joined-to-chat",
        icon: "headset_mic",
        message: (activity, that) =>
            that.$t("notification.chatJoined", {
                agent: getActorName(activity),
                visitor: maskActivityVisitorName(that.$_.get(activity, "payload.fullname"), activity),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chat");
        },
    },
    CONTACT_OWNER_UPDATED: {
        id: "contact-owner-updated",
        icon: "event_seat",
        message: (activity, that) =>
            that.$t("notification.customerOwnershipReassigned", {
                agent: that.$_.get(activity, "actorUser.name"),
                visitor: maskActivityVisitorName(that.$_.get(activity, "payload.visitorName"), activity),
                oldOwner: that.$_.get(activity, "payload.oldOwnerName"),
                newOwner: that.$_.get(activity, "payload.ownerName"),
            }),
    },

    // bu kısma geri dönülücek uı komponenti mevcut değil
    VISITOR_ONLINE: {
        id: "online",
        icon: "online_prediction",
        message: (activity) => `Ziyaretci Online Oldu`,
        onClick: (activity, that) => {
            that.$router.push("/visitors");
        },
    },
    // bu kısma geri dönülcek
    VISITOR_OFFLINE: {
        id: "offline",
        icon: "offline_bolt",
        message: (activity) => `Ziyaretci Offline Oldu`,
        onClick: (activity, that) => {
            that.$router.push("/visitors");
        },
    },
    // bu kısma geri dönülcek
    PAGE_CHANGED: {
        id: "page-changed",
        icon: "pageview",
        message: (activity) => `Sayfa Değiştirildi`,
        onClick: (activity, that) => {
            that.$router.push("/visitors");
        },
    },
    // bu kısma geri dönülecek
    VISITOR_CREATE_TICKET: {
        id: "create-ticket",
        icon: "confirmation_number",
        message: (activity) => `Ziyaretçi tarafından Ticket Eklendi`,
        onClick: (activity, that) => {
            that.$router.push("/ticket");
        },
    },
    // bu kısma geri dönülcek
    VIDEO_CALLING_STARTED: {
        id: "video-calling-started",
        icon: "videocam",
        message: (activity) => `Görüntülü Arama Başlatıldı`,
        onClick: (activity, that) => {
            that.$router.push("/archives");
        },
    },
    // bu kısma geri dönülcek
    VIDEO_CALLING_CLOSED: {
        id: "video-calling-closed",
        icon: "videocam_off",
        message: (activity) => `Görüntülü Arama Kapatıldı`,
        onClick: (activity, that) => {
            that.$router.push("/archives");
        },
    },
    // bu kısma geri dönülcek
    VOICE_CALLING_STARTED: {
        id: "voice-calling-started",
        icon: "support_agent",
        message: (activity) => `Sesli Arama Başlatıldı`,
        onClick: (activity, that) => {
            that.$router.push("/archives");
        },
    },
    // bu kısma geri dönülcek
    VOICE_CALLING_CLOSED: {
        id: "voice-calling-closed",
        icon: "phone_callback",
        message: (activity) => `Sesli Arama Kapatıldı`,
        onClick: (activity, that) => {
            that.$router.push("/archives");
        },
    },
    VISITOR_TAG_ADDED: {
        id: "visitor-tag-added",
        icon: "local_offer",
        message: (activity, that) => {
            const actor = getActorName(activity);
            const v = getActivityVisitor(activity);
            const raw = (v && v.fullname) || (v && v.email) || "Bilinmeyen";
            const visitorName = raw === "Bilinmeyen" ? raw : maskVisitorDisplayNameIfNeeded(raw, _.get(activity, "refVisitor"));
            const tagNames = _.get(activity, "refTags", []).map(tag => tag.name).join(", ") || "Etiketler";
            return that.$t("auto.activityVisitorTagAdded", { actor, visitorName, tagNames });
        },
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", (getActivityVisitor(activity) || {})._id);
        },
    },
    VISITOR_TAG_REMOVED: {
        id: "visitor-tag-removed",
        icon: "local_offer",
        message: (activity, that) => {
            const actor = getActorName(activity);
            const v = getActivityVisitor(activity);
            const raw = (v && v.fullname) || (v && v.email) || "Bilinmeyen";
            const visitorName = raw === "Bilinmeyen" ? raw : maskVisitorDisplayNameIfNeeded(raw, _.get(activity, "refVisitor"));
            const tagNames = _.get(activity, "refTags", []).map(tag => tag.name).join(", ") || "Etiketler";
            return that.$t("auto.activityVisitorTagRemoved", { actor, visitorName, tagNames });
        },
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", (getActivityVisitor(activity) || {})._id);
        },
    },

    // bu kısma geri dönülecek
    NOTE_CREATED: {
        id: "note-created",
        icon: "edit_note",
        message: (activity) => `Not Eklendi`,
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },
    // bu kısma geri dönülecek
    NOTE_UPDATED: {
        id: "note-updated",
        icon: "edit_note",
        message: (activity) => `Not Güncellendi`,
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },

    // bu kısma geri dönülecek
    VISITOR_PROFILE_UPDATED: {
        id: "visitor-profile-updated",
        icon: "account_circle",
        message: (activity) => `Ziyaretçi Profili Güncellendi`,
        onClick: (activity, that) => {
            that.$store.commit("app/SET_VISITOR_DETAIL_POPUP", _.get(activity, "refVisitor._id"));
        },
    },

    USER_ADDED: {
        id: "user-added",
        icon: "person_add",
        message: (activity, that) =>
            that.$t("notification.userAdded", {
                newAgent: that.$_.get(activity, "payload.name"),
                agent: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("company-users", that);
        },
    },
    USER_REMOVED: {
        id: "user-removed",
        icon: "assignment_ind",
        message: (activity, that) =>
            that.$t("notification.userRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                oldUser: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("company-users", that);
        },
    },
    USER_STATUS_CHANGED: {
        id: "user-status-changed",
        icon: "signal_wifi_statusbar_null",
        message: (activity, that) =>
            that.$t("notification.userStatusChanged", {
                name: that.$_.get(activity, "payload.name"),
                oldStatus: that.$_.get(activity, "payload.oldStatus"),
                newStatus: that.$_.get(activity, "payload.newStatus"),
            }),
        onClick: (activity, that) => {
            settingPageChange("company-users", that);
        },
    },
    USER_LOGGED_IN: {
        id: "user-logged-in",
        icon: "login",
        message: (activity, that) => that.$t("notification.userLoggenIn", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            settingPageChange("company-users", that);
        },
    },
    USER_ADDED_TO_DEPARTMENT: {
        id: "user-added-to-department",
        icon: "local_fire_department",
        message: (activity, that) =>
            that.$t("notification.userAddedToDepartment", {
                user1: that.$_.get(activity, "actorUser.name"),
                user2: that.$_.get(activity, "payload.userName"),
                department: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("departments", that);
        },
    },
    USER_REMOVED_FROM_DEPARTMENT: {
        id: "user-removed-from-depart",
        icon: "local_fire_department",
        message: (activity, that) =>
            that.$t("notification.userRemovedToDepartment", {
                user1: that.$_.get(activity, "actorUser.name"),
                user2: that.$_.get(activity, "payload.userName"),
                department: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("departments", that);
        },
    },

    SETTINGS_UPDATED: {
        id: "settings-updated",
        icon: "settings",
        message: (activity, that) =>
            that.$t("notification.settingsUpdatedWoDetail", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            settingPageChange("departments", that);
        },
    },

    WHATSAPP_BROADCAST_CREATED: {
        id: "whatsapp-broadcast-created",
        icon: "cell_tower",
        message: (activity, that) =>
            that.$t("notification.whatsappBroadcastCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                title: that.$_.get(activity, "payload.title"),
                numbers: that.$_.get(activity, "payload.numbers"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WHATSAPP_BROADCAST_CANCELED: {
        id: "whatsapp-broadcast-canceled",
        icon: "cell_tower",
        message: (activity, that) =>
            that.$t("notification.whatsappBroadcastCancelled", { title: that.$_.get(activity, "payload.title") }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WHATSAPP_BROADCAST_COMPLETED: {
        id: "whatsapp-broadcast-completed",
        icon: "cell_tower",
        message: (activity, that) =>
            that.$t("notification.whatsappBroadcastCompleted", {
                title: that.$_.get(activity, "payload.title"),
                numbers: that.$_.get(activity, "payload.numbers"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WHATSAPP_BROADCAST_FAILED: {
        id: "whatsapp-broadcast-failed",
        icon: "cell_tower",
        message: (activity, that) =>
            that.$t("notification.whatsappBroadcastFailed", { title: that.$_.get(activity, "payload.title") }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WHATSAPP_V1_BOT_STATE_CHANGED: {
        id: "whatsapp-v1-bot-state-changed",
        icon: "qr_code_scanner",
        message: (activity) =>
            `${_.get(activity, "actor")}: ${_.get(activity, "payload.channelName")} state changed form ${_.get(
                activity,
                "payload.oldState"
            )} to ${_.get(activity, "payload.newState")}`,
    },
    WHATSAPP_V2_BOT_STATE_CHANGED: {
        id: "whatsapp-v2-bot-state-changed",
        icon: "qr_code_scanner",
        message: (activity) =>
            `${_.get(activity, "actor")}: ${_.get(activity, "payload.channelName")} state changed form ${_.get(
                activity,
                "payload.oldState"
            )} to ${_.get(activity, "payload.newState")}`,
    },
    WABA_SUPSIS_PARTNER_REMOVE: {
        id: "waba_supsis_partner_remove",
        icon: "link_off",
        message: (activity) => {
            const wabaId = _.get(activity, "payload.waba_info.waba_id");
            const ownerBusinessId = _.get(activity, "payload.waba_info.owner_business_id");
            const channelId = _.get(activity, "payload.channelId");
            const details = [wabaId ? `waba_id: ${wabaId}` : null, ownerBusinessId ? `owner_business_id: ${ownerBusinessId}` : null]
                .filter(Boolean)
                .join(", ");
            const suffix = details ? ` (${details})` : "";
            const channelSuffix = channelId ? ` kanalId: ${channelId}` : "";
            return `Whatsapp Business API V2 partner kaldırıldı${suffix}.${channelSuffix}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_PARTNER_REMOVE_LEGACY: {
        id: "waba_supsis_PARTNER_REMOVE",
        icon: "link_off",
        message: (activity) => {
            const wabaId = _.get(activity, "payload.waba_info.waba_id");
            const ownerBusinessId = _.get(activity, "payload.waba_info.owner_business_id");
            const channelId = _.get(activity, "payload.channelId");
            const details = [wabaId ? `waba_id: ${wabaId}` : null, ownerBusinessId ? `owner_business_id: ${ownerBusinessId}` : null]
                .filter(Boolean)
                .join(", ");
            const suffix = details ? ` (${details})` : "";
            const channelSuffix = channelId ? ` kanalId: ${channelId}` : "";
            return `Whatsapp Business API V2 partner kaldırıldı${suffix}.${channelSuffix}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_PARTNER_ADDED: {
        id: "waba_supsis_partner_added",
        icon: "person_add",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const wabaId = _.get(activity, "payload.waba_info.waba_id");
            const ownerBusinessId = _.get(activity, "payload.waba_info.owner_business_id");
            const solutionId = _.get(activity, "payload.waba_info.solution_id");
            const solutionPartnerBusinessIds = _.get(activity, "payload.waba_info.solution_partner_business_ids", []);
            const solutionPartnerIdsStr = Array.isArray(solutionPartnerBusinessIds) 
                ? solutionPartnerBusinessIds.join(", ") 
                : String(solutionPartnerBusinessIds || "");
            const suffix = [
                wabaId ? `waba_id: ${wabaId}` : null,
                ownerBusinessId ? `owner_business_id: ${ownerBusinessId}` : null,
                solutionId ? `solution_id: ${solutionId}` : null,
                solutionPartnerIdsStr ? `solution_partner_business_ids: ${solutionPartnerIdsStr}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 partner eklendi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_ACCOUNT_DELETED: {
        id: "waba_supsis_account_deleted",
        icon: "delete_forever",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const accountId = _.get(activity, "payload.entry.0.id");
            const suffix = [accountId ? `accountId: ${accountId}` : null, channelId ? `kanalId: ${channelId}` : null]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 hesabı silindi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_ACCOUNT_DELETED_LEGACY: {
        id: "waba_supsis_ACCOUNT_DELETED",
        icon: "delete_forever",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const accountId = _.get(activity, "payload.entry.0.id");
            const suffix = [accountId ? `accountId: ${accountId}` : null, channelId ? `kanalId: ${channelId}` : null]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 hesabı silindi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_ACCOUNT_VIOLATION: {
        id: "waba_supsis_account_violation",
        icon: "warning",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const violationType = _.get(activity, "payload.violation_info.violation_type");
            const accountId = _.get(activity, "payload.entry.0.id");
            const suffix = [
                violationType ? `violation_type: ${violationType}` : null,
                accountId ? `accountId: ${accountId}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 hesap ihlali tespit edildi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_AD_ACCOUNT_LINKED: {
        id: "waba_supsis_ad_account_linked",
        icon: "link",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const wabaId = _.get(activity, "payload.waba_info.waba_id");
            const ownerBusinessId = _.get(activity, "payload.waba_info.owner_business_id");
            const adAccountLinked = _.get(activity, "payload.waba_info.ad_account_linked");
            const suffix = [
                wabaId ? `waba_id: ${wabaId}` : null,
                ownerBusinessId ? `owner_business_id: ${ownerBusinessId}` : null,
                adAccountLinked ? `ad_account_linked: ${adAccountLinked}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 reklam hesabı bağlandı${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_AUTH_INTL_PRICE_ELIGIBILITY_UPDATE: {
        id: "waba_supsis_auth_intl_price_eligibility_update",
        icon: "price_change",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const startTime = _.get(activity, "payload.auth_international_rate_eligibility.start_time");
            const exceptionCountries = _.get(activity, "payload.auth_international_rate_eligibility.exception_countries", []);
            const exceptionCountriesStr = exceptionCountries.length > 0
                ? exceptionCountries.map((c) => c.country_code).join(", ")
                : null;
            const suffix = [
                startTime ? `start_time: ${startTime}` : null,
                exceptionCountriesStr ? `exception_countries: ${exceptionCountriesStr}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 uluslararası fiyat uygunluk güncellemesi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_DISABLED_UPDATE: {
        id: "waba_supsis_disabled_update",
        icon: "block",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const wabaBanState = _.get(activity, "payload.ban_info.waba_ban_state");
            const wabaBanDate = _.get(activity, "payload.ban_info.waba_ban_date");
            const suffix = [
                wabaBanState ? `waba_ban_state: ${wabaBanState}` : null,
                wabaBanDate ? `waba_ban_date: ${wabaBanDate}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 devre dışı bırakma güncellemesi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_MM_LITE_TERMS_SIGNED: {
        id: "waba_supsis_mm_lite_terms_signed",
        icon: "fact_check",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const wabaId = _.get(activity, "payload.waba_info.waba_id");
            const ownerBusinessId = _.get(activity, "payload.waba_info.owner_business_id");
            const suffix = [
                wabaId ? `waba_id: ${wabaId}` : null,
                ownerBusinessId ? `owner_business_id: ${ownerBusinessId}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 MM Lite şartları imzalandı${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_PARTNER_APP_INSTALLED: {
        id: "waba_supsis_partner_app_installed",
        icon: "install_mobile",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const wabaId = _.get(activity, "payload.waba_info.waba_id");
            const ownerBusinessId = _.get(activity, "payload.waba_info.owner_business_id");
            const partnerAppId = _.get(activity, "payload.waba_info.partner_app_id");
            const solutionId = _.get(activity, "payload.waba_info.solution_id");
            const solutionPartnerBusinessIds = _.get(activity, "payload.waba_info.solution_partner_business_ids", []);
            const suffix = [
                wabaId ? `waba_id: ${wabaId}` : null,
                ownerBusinessId ? `owner_business_id: ${ownerBusinessId}` : null,
                partnerAppId ? `partner_app_id: ${partnerAppId}` : null,
                solutionId ? `solution_id: ${solutionId}` : null,
                solutionPartnerBusinessIds.length > 0 ? `solution_partner_business_ids: [${solutionPartnerBusinessIds.join(", ")}]` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 partner uygulaması yüklendi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_PARTNER_APP_UNINSTALLED: {
        id: "waba_supsis_partner_app_uninstalled",
        icon: "delete_forever",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const wabaId = _.get(activity, "payload.waba_info.waba_id");
            const ownerBusinessId = _.get(activity, "payload.waba_info.owner_business_id");
            const partnerAppId = _.get(activity, "payload.waba_info.partner_app_id");
            const suffix = [
                wabaId ? `waba_id: ${wabaId}` : null,
                ownerBusinessId ? `owner_business_id: ${ownerBusinessId}` : null,
                partnerAppId ? `partner_app_id: ${partnerAppId}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 partner uygulaması kaldırıldı${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_PARTNER_CLIENT_CERTIFICATION_STATUS_UPDATE: {
        id: "waba_supsis_partner_client_certification_status_update",
        icon: "verified_user",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const clientBusinessId = _.get(activity, "payload.partner_client_certification_info.client_business_id");
            const status = _.get(activity, "payload.partner_client_certification_info.status");
            const rejectionReasons = _.get(activity, "payload.partner_client_certification_info.rejection_reasons", []);
            const suffix = [
                clientBusinessId ? `client_business_id: ${clientBusinessId}` : null,
                status ? `status: ${status}` : null,
                rejectionReasons.length > 0 && rejectionReasons[0] !== "NONE" ? `rejection_reasons: [${rejectionReasons.join(", ")}]` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 partner müşteri sertifikasyon durumu güncellendi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_BUSINESS_PRIMARY_LOCATION_COUNTRY_UPDATE: {
        id: "waba_supsis_business_primary_location_country_update",
        icon: "public",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const country = _.get(activity, "payload.country");
            const suffix = [
                country ? `ülke: ${country}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 birincil konum ülkesi güncellendi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_VOLUME_BASED_PRICING_TIER_UPDATE: {
        id: "waba_supsis_volume_based_pricing_tier_update",
        icon: "trending_up",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const tier = _.get(activity, "payload.volume_tier_info.tier");
            const pricingCategory = _.get(activity, "payload.volume_tier_info.pricing_category");
            const effectiveMonth = _.get(activity, "payload.volume_tier_info.effective_month");
            const region = _.get(activity, "payload.volume_tier_info.region");
            const suffix = [
                tier ? `tier: ${tier}` : null,
                pricingCategory ? `kategori: ${pricingCategory}` : null,
                effectiveMonth ? `geçerli ay: ${effectiveMonth}` : null,
                region ? `bölge: ${region}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 hacim bazlı fiyatlandırma seviyesi güncellendi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_MESSAGE_TEMPLATE_COMPONENTS_UPDATE: {
        id: "waba_supsis_message_template_components_update",
        icon: "article",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const templateName = _.get(activity, "payload.message_template_name");
            const templateTitle = _.get(activity, "payload.message_template_title");
            const templateLanguage = _.get(activity, "payload.message_template_language");
            const suffix = [
                templateName ? `şablon: ${templateName}` : null,
                templateTitle ? `başlık: ${templateTitle}` : null,
                templateLanguage ? `dil: ${templateLanguage}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 mesaj şablonu bileşenleri güncellendi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_MESSAGE_TEMPLATE_STATUS_UPDATE: {
        id: "waba_supsis_message_template_status_update",
        icon: "speed",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const templateName = _.get(activity, "payload.message_template_name");
            const templateLanguage = _.get(activity, "payload.message_template_language");
            const previousQualityScore = _.get(activity, "payload.previous_quality_score");
            const newQualityScore = _.get(activity, "payload.new_quality_score");
            const originalEvent = _.get(activity, "payload.originalEvent");
            const reason = _.get(activity, "payload.reason");
            const category = _.get(activity, "payload.message_template_category");
            const suffix = [
                templateName ? `şablon: ${templateName}` : null,
                originalEvent ? `durum: ${originalEvent}` : null,
                previousQualityScore && newQualityScore ? `kalite: ${previousQualityScore} → ${newQualityScore}` : null,
                category ? `kategori: ${category}` : null,
                reason && reason !== "NONE" ? `sebep: ${reason}` : null,
                templateLanguage ? `dil: ${templateLanguage}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 mesaj şablonu durumu güncellendi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    WABA_SUPSIS_TEMPLATE_CATEGORY_UPDATE: {
        id: "waba_supsis_template_category_update",
        icon: "category",
        message: (activity) => {
            const channelId = _.get(activity, "payload.channelId");
            const templateName = _.get(activity, "payload.message_template_name");
            const templateLanguage = _.get(activity, "payload.message_template_language");
            const previousCategory = _.get(activity, "payload.previous_category");
            const newCategory = _.get(activity, "payload.new_category");
            const correctCategory = _.get(activity, "payload.correct_category");
            let categoryChange = null;
            if (previousCategory && newCategory) {
                categoryChange = `kategori: ${previousCategory} → ${newCategory}`;
            } else if (newCategory && correctCategory) {
                categoryChange = `kategori: ${newCategory} → ${correctCategory}`;
            }
            const suffix = [
                templateName ? `şablon: ${templateName}` : null,
                categoryChange,
                templateLanguage ? `dil: ${templateLanguage}` : null,
                channelId ? `kanalId: ${channelId}` : null,
            ]
                .filter(Boolean)
                .join(", ");
            const detail = suffix ? ` (${suffix})` : "";
            return `Whatsapp Business API V2 şablon kategorisi güncellendi${detail}`.trim();
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },

    CHANNEL_CREATED: {
        id: "channel-created",
        icon: "add_circle_outline",
        message: (activity, that) =>
            that.$t("notification.channelCreated", {
                name: that.$_.get(activity, "actorUser.name"),
                channel: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push(
                `/integrations/${_.get(activity, "payload.type")}/${_.get(activity, "payload._id")}/detail`
            );
        },
    },
    CHANNEL_REMOVED: {
        id: "channel-removed",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.channelRemoved", {
                channel: that.$_.get(activity, "payload.name"),
                agent: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    CHANNEL_VISIBILITY_CHANGED: {
        id: "channel-visibility-changed",
        icon: "visibility",
        message: (activity, that) =>
            that.$t("notification.channelVisibilityChanged", {
                channel: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        },
    },
    CHANNEL_FORWARD_CONFIG_UPDATED: {
        id: "channel-forward-config-updated",
        icon: "forward",
        message: (activity, that) => {
            const channelType = that.$_.get(activity, "payload.type");
            let channelTypeName = channelType;
            if (channelType === "facebook") channelTypeName = "Facebook";
            else if (channelType === "instagram") channelTypeName = "Instagram";
            else if (channelType === "instagram-v2") channelTypeName = "Instagram V2";
            else if (channelType === "whatsapp") channelTypeName = "WhatsApp";
            else if (channelType === "telegram") channelTypeName = "Telegram";
            else if (channelType === "web") channelTypeName = "Web";
            
            return that.$t("notification.channelForwardConfigUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                channelName: that.$_.get(activity, "payload.name"),
                channelType: channelTypeName
            });
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        }
    },
    CHANNEL_ZOHO_CONFIG_UPDATED: {
        id: "channel-zoho-config-updated",
        icon: "sync_alt",
        message: (activity, that) => {
            const channelType = that.$_.get(activity, "payload.type");
            let channelTypeName = channelType;
            if (channelType === "facebook") channelTypeName = "Facebook";
            else if (channelType === "instagram") channelTypeName = "Instagram";
            else if (channelType === "instagram-v2") channelTypeName = "Instagram V2";
            else if (channelType === "whatsapp") channelTypeName = "WhatsApp";
            else if (channelType === "telegram") channelTypeName = "Telegram";
            else if (channelType === "web") channelTypeName = "Web";
            
            return that.$t("notification.channelZohoConfigUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                channelName: that.$_.get(activity, "payload.name"),
                channelType: channelTypeName
            });
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations");
        }
    },

    LOGIN_FORM_ACTIVATED: {
        id: "login-form-activated",
        icon: "list",
        message: (activity, that) =>
            that.$t("notification.loginFormActivated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            settingPageChange("visitor-login-form", that);
        },
    },
    LOGIN_FORM_DEACTIVATED: {
        id: "login-form-deactivated",
        icon: "list",
        message: (activity, that) =>
            that.$t("notification.loginFormDeactivated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            settingPageChange("visitor-login-form", that);
        },
    },
    LOGIN_FORM_UPDATED: {
        id: "login-form-updated",
        icon: "list",
        message: (activity, that) =>
            that.$t("notification.loginFormUpdated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            settingPageChange("visitor-login-form", that);
        },
    },

    CHATBOT_CREATED: {
        id: "chatbot-created",
        icon: "smart_toy",
        message: (activity, that) =>
            that.$t("notification.chatbotCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                chatbot: that.$_.get(activity, "payload.title"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chatbot/stories");
        },
    },
    CHATBOT_DELETED: {
        id: "chatbot-deleted",
        icon: "smart_toy",
        message: (activity, that) =>
            that.$t("notification.chatbotDeleted", {
                user: that.$_.get(activity, "actorUser.name"),
                chatbot: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chatbot/stories");
        },
    },
    CHATBOT_RESTORED: {
        id: "chatbot-restored",
        icon: "restore",
        message: (activity, that) =>
            that.$t("notification.chatbotRestored", {
                user: that.$_.get(activity, "actorUser.name"),
                chatbot: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chatbot/stories");
        },
    },
    CHATBOT_PUBLISHED: {
        id: "chatbot-published",
        icon: "smart_toy",
        message: (activity, that) =>
            that.$t("notification.chatbotPublished", {
                user: that.$_.get(activity, "actorUser.name"),
                version: that.$_.get(activity, "payload.version"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chatbot/stories");
        },
    },
    // bu kısma geri dönülecek
    CHATBOT_WEBHOOK_ADDED: {
        id: "chatbot-webhook-added",
        icon: "smart_toy",
        message: (activity) => `Chatbot webhook added`,
        onClick: (activity, that) => {
            that.$router.push("/chatbot/integrations/webhook");
        },
    },
    // bu kısma geri dönülücek
    CHATBOT_WEBHOOK_REMOVED: {
        id: "chatbot-webhook-removed",
        icon: "smart_toy",
        message: (activity) => `Chatbot webhook removed`,
        onClick: (activity, that) => {
            that.$router.push("/chatbot/integrations/webhook");
        },
    },

    CHATBOT_AI_MODEL_UPDATED: {
        id: "chatbot-ai-model-updated",
        icon: "model_training",
        message: (activity, that) =>
            that.$t("notification.chatbotAiModelUpdated", {
                user: that.$_.get(activity, "actorUser.name"),
                chatbotName: that.$_.get(activity, "payload.chatbotName"),
                oldModel: that.$_.get(activity, "payload.oldModel"),
                newModel: that.$_.get(activity, "payload.newModel"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/chatbot/stories");
        },
    },

    BANNED_WORD_ADDED: {
        id: "banned-word-added",
        icon: "sync_lock",
        message: (activity, that) =>
            that.$t("notification.bannedWordCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                bWord: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("forbidden-inputs", that);
        },
    },
    BANNED_WORD_REMOVED: {
        id: "banned-word-removed",
        icon: "sync_lock",
        message: (activity, that) =>
            that.$t("notification.bannedWordRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                bWord: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("forbidden-inputs", that);
        },
    },

    // bu mail kısmına geri dönülecek
    MAIL_ADDRESS_ADDED: {
        id: "mail-address-added",
        icon: "email",
        message: (activity, that) =>
            that.$t("notification.mailAddressAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                email: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/mails");
        },
    },
    MAIL_ADDRESS_REMOVED: {
        id: "mail-address-removed",
        icon: "email",
        message: (activity, that) => that.$t("notification.mailAdressRemoved"),
        onClick: (activity, that) => {
            that.$router.push("/mails");
        },
    },
    MAIL_WAS_SENT: {
        id: "mail-was-sent",
        icon: "email",
        message: (activity, that) => that.$t("notification.mailWasSent"),
        onClick: (activity, that) => {
            that.$router.push("/mails");
        },
    },

    CONTENT_ADDED: {
        id: "content-added",
        icon: "inventory_2",
        message: (activity, that) =>
            that.$t("notification.contentAdded", {
                content: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("templates", that);
        },
    },
    CONTENT_REMOVED: {
        id: "content-removed",
        icon: "inventory_2",
        message: (activity, that) =>
            that.$t("notification.contentRemoved", {
                content: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("templates", that);
        },
    },

    ROLE_ADDED: {
        id: "role-added",
        icon: "extension",
        message: (activity, that) =>
            that.$t("notification.roleAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                role: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("roles", that);
        },
    },
    ROLE_REMOVED: {
        id: "role-removed",
        icon: "extension",
        message: (activity, that) =>
            that.$t("notification.roleRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                role: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("roles", that);
        },
    },

    DEPARTMENT_ADDED: {
        id: "department-added",
        icon: "apartment",
        message: (activity, that) =>
            that.$t("notification.departmentAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                department: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("departments", that);
        },
    },
    DEPARTMENT_REMOVED: {
        id: "department-removed",
        icon: "apartment",
        message: (activity, that) =>
            that.$t("notification.departmentRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                department: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("departments", that);
        },
    },

    TAGS_ADDED: {
        id: "tags-added",
        icon: "style",
        message: (activity, that) =>
            that.$t("notification.tagAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                tag: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/visitors?tab=tags");
        },
    },
    TAGS_REMOVED: {
        id: "tags-removed",
        icon: "style",
        message: (activity, that) =>
            that.$t("notification.tagRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                tag: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/visitors?tab=tags");
        },
    },

    TRIGGER_ADDED: {
        id: "trigger-added",
        icon: "notifications",
        message: (activity, that) =>
            that.$t("notification.triggerAdded", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/webchat/triggers");
        },
    },
    TRIGGER_REMOVED: {
        id: "trigger-removed",
        icon: "notifications",
        message: (activity, that) =>
            that.$t("notification.triggerRemoved", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/webchat/triggers");
        },
    },
    TRIGGER_UPDATED: {
        id: "trigger-updated",
        icon: "notifications",
        message: (activity, that) =>
            that.$t("notification.triggerUpdated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/webchat/triggers");
        },
    },

    WELCOME_MESSAGE_ADDED: {
        id: "welcome-message-added",
        icon: "send_time_extension",
        message: (activity, that) =>
            that.$t("notification.welcomeMessageAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                welcome: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("system-messages", that);
        },
    },
    WELCOME_MESSAGE_REMOVED: {
        id: "welcome-message-removed",
        icon: "assignment_ind",
        message: (activity, that) =>
            that.$t("notification.welcomeMessageRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                welcome: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("system-messages", that);
        },
    },

    CUSTOMER_GROUP_ADDED: {
        id: "customer-group-added",
        icon: "groups",
        message: (activity, that) =>
            that.$t("notification.customerGroupAdded", {
                group: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/whatsapp-business-api");
        },
    },
    CUSTOMER_GROUP_REMOVED: {
        id: "customer-group-removed",
        icon: "groups",
        message: (activity, that) =>
            that.$t("notification.customerGroupRemoved", {
                group: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/whatsapp-business-api");
        },
    },
    CUSTOMER_GROUP_UPDATED: {
        id: "customer-group-updated",
        icon: "groups",
        message: (activity, that) =>
            that.$t("notification.customerGroupUpdated", {
                group: that.$_.get(activity, "payload.name"),
                user: that.$_.get(activity, "actorUser.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/whatsapp-business-api");
        },
    },

    WEBHOOK_ADDED: {
        id: "webhook-added",
        icon: "webhook",
        message: (activity, that) =>
            that.$t("notification.webhookAdded", {
                user1: that.$_.get(activity, "actorUser.name"),
                user2: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/webhook");
        },
    },
    WEBHOOK_REMOVED: {
        id: "webhook-removed",
        icon: "webhook",
        message: (activity, that) =>
            that.$t("notification.webhookRemoved", {
                user1: that.$_.get(activity, "actorUser.name"),
                user2: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/integrations/webhook");
        },
    },
    WEBHOOK_UPDATED: {
        id: "webhook-updated",
        icon: "webhook",
        message: (activity, that) => {
            return that.$t("notification.webhookUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                webhookName: that.$_.get(activity, "payload.name"),
                webhookUrl: that.$_.get(activity, "payload.url")
            });
        },
        onClick: (activity, that) => {
            that.$router.push("/integrations/webhook");
        }
    },
    CONTACT_PROP_ADDED: {
        id: "contact-prop-added",
        icon: "connect_without_contact",
        message: (activity, that) =>
            that.$t("notification.contactPropAdded", {
                user: that.$_.get(activity, "actorUser.name"),
                prop: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("visitor-attribute", that);
        },
    },
    CONTACT_PROP_REMOVED: {
        id: "contact-prop-removed",
        icon: "connect_without_contact",
        message: (activity, that) =>
            that.$t("notification.contactPropRemoved", {
                user: that.$_.get(activity, "actorUser.name"),
                prop: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            settingPageChange("visitor-attribute", that);
        },
    },
    INVOICE_CREATED: {
        id: "invoice-created",
        icon: "featured_play_list",
        message: (activity, that) => that.$t("notification.invoiceCreated", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            that.$router.push("/settings/billing");
        },
    },
    PLAN_STARTED: {
        id: "plan-started",
        icon: "featured_play_list",
        message: (activity, that) => {
            if (that.$_.get(activity, "payload.details")) {
                return that.$t("notification.planStartedAgent", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    details: that.$_.get(activity, "payload.details"),
                });
            } else if (that.$_.get(activity, "payload.detailsChatbot")) {
                return that.$t("notification.planStartedChatbot", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    chatbot: that.$_.get(activity, "payload.detailsChatbot"),
                });
            } else if (that.$_.get(activity, "payload.detailsWp")) {
                return that.$t("notification.planStartedWhatsapp", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    whatsapp: that.$_.get(activity, "payload.detailsWp"),
                });
            } else if (that.$_.get(activity, "payload.detailWpApi")) {
                return that.$t("notification.planStartedWhatsappApi", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    whatsappApi: that.$_.get(activity, "payload.detailWpApi"),
                });
            }
        },
        onClick: (activity, that) => {
            that.$router.push("/settings/billing");
        },
    },
    PLAN_CANCELED: {
        id: "plan-canceled",
        icon: "featured_play_list",
        message: (activity, that) => {
            if (that.$_.get(activity, "payload.details")) {
                return that.$t("notification.planCanceledAgent", {
                    user: getActorName(activity),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    details: that.$_.get(activity, "payload.details"),
                });
            } else if (that.$_.get(activity, "payload.detailsChatbot")) {
                return that.$t("notification.planCanceledChatbot", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    chatbot: that.$_.get(activity, "payload.detailsChatbot"),
                });
            } else if (that.$_.get(activity, "payload.detailsWp")) {
                return that.$t("notification.planCanceledWhatsapp", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    whatsapp: that.$_.get(activity, "payload.detailsWp"),
                });
            } else if (that.$_.get(activity, "payload.detailWpApi")) {
                return that.$t("notification.planCanceledWhatsappApi", {
                    user: that.$_.get(activity, "actorUser.name"),
                    title: that.$_.get(activity, "payload.title"),
                    altTitle: that.$_.get(activity, "payload.altTitle"),
                    whatsappApi: that.$_.get(activity, "payload.detailWpApi"),
                });
            }
        },
        onClick: (activity, that) => {
            that.$router.push("/settings/billing");
        },
    },
    INVOICE_PAYMENT_RECEIVED: {
        id: "invoice-payment-received",
        icon: "featured_play_list",
        message: (activity, that) => that.$t("notification.invoicePaymentReceived", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            that.$router.push("/settings/billing");
        },
    },
    INVOICE_PAYMENT_FAILED: {
        id: "invoice-payment-failed",
        icon: "featured_play_list",
        message: (activity, that) => that.$t("notification.invoicePaymentFailed", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            that.$router.push("/settings/billing");
        },
    },
    INVOICE_REFUNDED: {
        id: "invoice-refunded",
        icon: "featured_play_list",
        message: (activity, that) => that.$t("notification.invoiceRefunded", { user: getActorName(activity) }),
        onClick: (activity, that) => {
            that.$router.push("/settings/billing");
        },
    },
    PAYMENT_METHOD_ADDED: {
        id: "payment-method-added",
        icon: "featured_play_list",
        message: (activity, that) =>
            that.$t("notification.paymentMethodAdded", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/settings/billing");
        },
    },
    BILLING_ADDRESS_UPDATED: {
        id: "billing-address-updated",
        icon: "featured_play_list",
        message: (activity, that) =>
            that.$t("notification.billingAddressUpdated", { user: that.$_.get(activity, "actorUser.name") }),
        onClick: (activity, that) => {
            that.$router.push("/settings/billing");
        },
    },

    TASK_WORKFLOW_CREATED: {
        id: "task-workflow-created",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskWFlowCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                Wflow: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/tasks");
        },
    },
    TASK_WORKFLOW_DELETED: {
        id: "task-workflow-deleted",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskWorkflowDeleted", {
                user: that.$_.get(activity, "actorUser.name"),
                workflow: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/tasks");
        },
    },
    TASK_WORKFLOW_RESTORED: {
        id: "task-workflow-restored",
        icon: "restore",
        message: (activity, that) =>
            that.$t("notification.taskWorkflowRestored", {
                user: that.$_.get(activity, "actorUser.name"),
                workflow: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/tasks");
        },
    },
    TASK_WORKFLOW_PERMANENTLY_DELETED: {
        id: "task-workflow-permanently-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.taskWorkflowPermanentlyDeleted", {
                user: that.$_.get(activity, "actorUser.name"),
                workflow: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/tasks");
        },
    },
    TASK_CREATED: {
        id: "task-created",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                task: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_DELETED: {
        id: "task-deleted",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskDeleted", {
                user: that.$_.get(activity, "actorUser.name"),
                task: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push(`/tasks?workflow=${that.$_.get(activity, "payload.workflowId")}&type=kanban`);
        },
    },
    TASK_STAGE_CHANGED: {
        id: "task-stage-changed",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskStageChanged", {
                user: that.$_.get(activity, "actorUser.name"),
                task: that.$_.get(activity, "payload.name"),
                oldStage: that.$_.get(activity, "payload.oldStage"),
                newStage: that.$_.get(activity, "payload.newStage"),
            }),
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_WORKFLOW_CHANGED: {
        id: "task-workflow-changed",
        icon: "compare_arrows",
        message: (activity, that) => {
            const user = that.$_.get(activity, "actorUser.name") || "Bilinmeyen Kullanıcı";
            const taskTitle = that.$_.get(activity, "payload.name") || "Bilinmeyen Görev";
            const oldWorkflowName = that.$_.get(activity, "payload.oldWorkflowName") || "Bilinmeyen İş Akışı";
            const newWorkflowName = that.$_.get(activity, "payload.newWorkflowName") || "Bilinmeyen İş Akışı";
            return `${user} kullanıcısı "${taskTitle}" görevini "${oldWorkflowName}" iş akışından "${newWorkflowName}" iş akışına taşıdı.`;
        },
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.newWorkflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_ASSIGNED_TO_USER: {
        id: "task-assigned-to-user",
        icon: "add_task",
        message: (activity) => {
            let message = activity.actorUser.name + " kullanıcısı: ";
            let assignees = activity.payload.assignees;
            for (let i = 0; i < assignees.length; i++) {
                message += assignees[i] + ", ";
            }
            message += '"' + activity.payload.taskTitle + '" adlı göreve atadı.';
            return message;
        },
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_UPDATE_PRIORITY: {
        id: "task-update-priority",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskPriorityUpdated", {
                user: that.$_.get(activity, "actorUser.name"),
                oldPriority: that.$_.get(activity, "payload.oldPriority"),
                newPriority: that.$_.get(activity, "payload.newPriority"),
                taskTitle: that.$_.get(activity, "payload.taskTitle"),
            }),
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_ADDED_TAGS: {
        id: "task-added-tags",
        icon: "style",
        message: (activity, that) =>
            that.$t("notification.taskAddedTags", {
                user: that.$_.get(activity, "actorUser.name"),
                taskTitle: that.$_.get(activity, "payload.taskTitle"),
                tags: that.$_.get(activity, "payload.tags").join(", "),
            }),
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_REMOVED_TAGS: {
        id: "task-removed-tags",
        icon: "style",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı görevden şu etiketleri kaldırdı: ${that.$_.get(activity, "payload.tags").join(", ")}.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_UPDATE_TITLE: {
        id: "task-update-title",
        icon: "edit",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı görev başlığını "${that.$_.get(activity, "payload.oldTitle")}" den "${that.$_.get(activity, "payload.newTitle")}" olarak güncelledi.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_UPDATE_DESCRIPTION: {
        id: "task-update-description",
        icon: "description",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı görevin açıklamasını güncelledi.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_UPDATE_START_DATE: {
        id: "task-update-start-date",
        icon: "event",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı görevin başlangıç tarihini "${that.$_.get(activity, "payload.oldStartDateFormatted")}" den "${that.$_.get(activity, "payload.newStartDateFormatted")}" olarak güncelledi.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_UPDATE_END_DATE: {
        id: "task-update-end-date",
        icon: "event",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı görevin bitiş tarihini "${that.$_.get(activity, "payload.oldEndDateFormatted")}" den "${that.$_.get(activity, "payload.newEndDateFormatted")}" olarak güncelledi.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_UPDATE_OWNER: {
        id: "task-update-owner",
        icon: "person",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı görevin sahibini "${that.$_.get(activity, "payload.oldOwner")}" den "${that.$_.get(activity, "payload.newOwner")}" olarak değiştirdi.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_ADDED_FOLLOWERS: {
        id: "task-added-followers",
        icon: "group_add",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı göreve şu takipçileri ekledi: ${that.$_.get(activity, "payload.followers").join(", ")}.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_REMOVED_FOLLOWERS: {
        id: "task-removed-followers",
        icon: "group_remove",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı görevden şu takipçileri kaldırdı: ${that.$_.get(activity, "payload.followers").join(", ")}.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_ADDED_COLLABORATORS: {
        id: "task-added-collaborators",
        icon: "group_add",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı göreve şu işbirlikçileri ekledi: ${that.$_.get(activity, "payload.collaborators").join(", ")}.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },

    TASK_UPDATE_CHECKLIST: {
        id: "task-update-checklist",
        icon: "checklist",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı görevin kontrol listesini güncelledi. ${that.$_.get(activity, "payload.changeDescription")}`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_ADDED_SUBTASK: {
        id: "task-added-subtask",
        icon: "add_task",
        message: (activity, that) => {
            const userName = that.$_.get(activity, "actorUser.name") || "Bilinmeyen Kullanıcı";
            const taskTitle = that.$_.get(activity, "payload.taskTitle") || "Bilinmeyen Görev";
            const subtaskCount = that.$_.get(activity, "payload.subtaskCount") || 0;
            const subtasks = that.$_.get(activity, "payload.subtasks") || [];
            const subtaskList = Array.isArray(subtasks) && subtasks.length > 0 ? subtasks.join(", ") : "Alt görevler";
            
            return `${userName} kullanıcısı "${taskTitle}" adlı göreve ${subtaskCount} alt görev ekledi: ${subtaskList}.`;
        },
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_REMOVED_SUBTASK: {
        id: "task-removed-subtask",
        icon: "remove_circle",
        message: (activity, that) => {
            const userName = that.$_.get(activity, "actorUser.name") || "Bilinmeyen Kullanıcı";
            const taskTitle = that.$_.get(activity, "payload.taskTitle") || "Bilinmeyen Görev";
            const subtaskCount = that.$_.get(activity, "payload.subtaskCount") || 0;
            const subtasks = that.$_.get(activity, "payload.subtasks") || [];
            const subtaskList = Array.isArray(subtasks) && subtasks.length > 0 ? subtasks.join(", ") : "Alt görevler";
            
            return `${userName} kullanıcısı "${taskTitle}" adlı görevden ${subtaskCount} alt görevi sildi: ${subtaskList}.`;
        },
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_ADDED_ATTACHMENT: {
        id: "task-added-attachment",
        icon: "attach_file",
        message: (activity, that) => {
            const userName = that.$_.get(activity, "actorUser.name") || "Bilinmeyen Kullanıcı";
            const taskTitle = that.$_.get(activity, "payload.taskTitle") || "Bilinmeyen Görev";
            const attachmentCount = that.$_.get(activity, "payload.attachmentCount") || 0;
            const attachments = that.$_.get(activity, "payload.attachments") || [];
            const attachmentList = Array.isArray(attachments) && attachments.length > 0 ? attachments.join(", ") : "Dosyalar";
            
            return `${userName} kullanıcısı "${taskTitle}" adlı göreve ${attachmentCount} dosya ekledi: ${attachmentList}.`;
        },
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_COMMENT_ADDED: {
        id: "task-comment-added",
        icon: "comment",
        message: (activity, that) => {
            const userName = that.$_.get(activity, "actorUser.name") || "Bilinmeyen Kullanıcı";
            const taskTitle = that.$_.get(activity, "payload.taskTitle") || "Bilinmeyen Görev";
            const comment = that.$_.get(activity, "payload.comment") || "";
            const commentPreview = comment ? comment.substring(0, 50) + (comment.length > 50 ? "..." : "") : "";
            return `${userName} kullanıcısı "${taskTitle}" görevine yorum ekledi: "${commentPreview}"`;
        },
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_COMMENT_UPDATED: {
        id: "task-comment-updated",
        icon: "edit",
        message: (activity, that) => {
            const userName = that.$_.get(activity, "actorUser.name") || "Bilinmeyen Kullanıcı";
            const taskTitle = that.$_.get(activity, "payload.taskTitle") || "Bilinmeyen Görev";
            const oldComment = that.$_.get(activity, "payload.oldComment") || "";
            const newComment = that.$_.get(activity, "payload.newComment") || "";
            const oldCommentPreview = oldComment ? oldComment.substring(0, 30) + "..." : "";
            const newCommentPreview = newComment ? newComment.substring(0, 30) + "..." : "";
            return `${userName} kullanıcısı "${taskTitle}" görevindeki yorumu düzenledi. Eski: "${oldCommentPreview}" → Yeni: "${newCommentPreview}"`;
        },
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },
    TASK_COMMENT_DELETED: {
        id: "task-comment-deleted",
        icon: "delete",
        message: (activity, that) => {
            const userName = that.$_.get(activity, "actorUser.name") || "Bilinmeyen Kullanıcı";
            const taskTitle = that.$_.get(activity, "payload.taskTitle") || "Bilinmeyen Görev";
            const comment = that.$_.get(activity, "payload.comment") || "";
            const commentPreview = comment ? comment.substring(0, 50) + (comment.length > 50 ? "..." : "") : "";
            return `${userName} kullanıcısı "${taskTitle}" görevinden yorum sildi: "${commentPreview}"`;
        },
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId"
                )}&type=kanban`
            );
        },
    },

    TASK_COMPLETED: {
        id: "task-completed",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskCompleted", {
                user: that.$_.get(activity, "actorUser.name"),
                taskTitle: that.$_.get(activity, "payload.taskTitle"),
            }),
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId",
                )}&type=kanban`,
            );
        },
    },
    TASK_ARCHIVED: {
        id: "task-archived",
        icon: "task",
        message: (activity, that) =>
            that.$t("notification.taskArchived", {
                user: that.$_.get(activity, "actorUser.name"),
                task: that.$_.get(activity, "payload.taskTitle"),
            }),
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId",
                )}&type=kanban`,
            );
        },
    },
    TASK_RESTORED: {
        id: "task-restored",
        icon: "restore",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle") || that.$_.get(activity, "payload.name")}" adlı görevi çöp kutusundan geri çıkardı.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId") || that.$_.get(activity, "payload.id")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId",
                )}&type=kanban`,
            );
        },
    },
    TASK_UNARCHIVED: {
        id: "task-unarchived",
        icon: "unarchive",
        message: (activity, that) =>
            `${that.$_.get(activity, "actorUser.name")} kullanıcısı "${that.$_.get(activity, "payload.taskTitle")}" adlı görevi arşivden geri çıkardı.`,
        onClick: (activity, that) => {
            that.$router.push(
                `/tasks?taskId=${that.$_.get(activity, "payload.taskId")}&workflow=${that.$_.get(
                    activity,
                    "payload.workflowId",
                )}&type=kanban`,
            );
        },
    },

    TICKET_ASSIGNED_TO_USER: {
        id: "ticket-assigned-to-user",
        icon: "local_activity",
        message: (activity, that) =>
            that.$t("notification.ticketAssigned", {
                user1: getActorName(activity),
                user2: that.$_.get(activity, "payload.assignedUserName"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/ticket");
        },
    },

    CHATBOT_CREDIT_LOW: {
        id: "chatbot-credit-low",
        icon: "report",
        message: () => `Chatbot credit is almost over. %90 ChatBot Credit Used.`,
    },
    CHATBOT_CREDIT_DONE: {
        id: "Fchatbot-credit-done",
        icon: "disc_full",
        message: () => `Chatbot session is done.`,
    },
    AUTOMATION_TASK_CREDIT_LOW: {
        id: "automation-task-credit-low",
        icon: "warning",
        message: () => `Otomasyon görevi kredisi neredeyse bitmek üzere. %90 otomasyon görevi kredisi kullanıldı.`,
    },
    AUTOMATION_TASK_CREDIT_DONE: {
        id: "automation-task-credit-done",
        icon: "error",
        message: () => `Otomasyon görevi kredisi bitti.`,
    },
    FORM_VIEW_LIMIT_LOW: {
        id: "form-view-limit-low",
        icon: "warning",
        message: (activity) => `"${_.get(activity, "payload.formName", "")}" formunun görüntüleme limiti neredeyse dolmak üzere. %90 form görüntüleme limiti kullanıldı.`,
    },
    FORM_VIEW_LIMIT_DONE: {
        id: "form-view-limit-done",
        icon: "error",
        message: (activity) => `"${_.get(activity, "payload.formName", "")}" formunun görüntüleme limiti doldu.`,
    },
    SYSTEM_STATUS: {
        id: "system-status",
        icon: "update",
        message: (activity) => `System status is ${_.get(activity, "payload.status") === true ? "Online" : "Offline"}.`,
    },
    WHATSAPP_CREDIT_LOW: {
        id: "whatsapp-credit-low",
        message: (activity) => `Whatsapp credit has dropped to ${_.get(activity, "payload.balance")}₺!`,
    },
    RESERVATION_CREATED_PLAN: {
        id: "reservation-created-plan",
        icon: "today",
        message: (activity, that) =>
            that.$t("notification.reservationCreatedPlan", {
                name: that.$_.get(activity, "actorUser.name"),
                title: that.$_.get(activity, "payload.title"),
                date: that.$_.get(activity, "payload.customProgramDates.startDate"),
            }),
    },
    RESERVATION_UPDATED_PLAN: {
        id: "reservation-updated-plan",
        icon: "event_repeat",
        message: (activity, that) =>
            that.$t("notification.reservationUpdatedPlan", {
                name: that.$_.get(activity, "actorUser.name"),
                title: that.$_.get(activity, "payload.title"),
            }),
    },
    RESERVATION_DELETED_PLAN: {
        id: "reservation-deleted-plan",
        icon: "event_busy",
        message: (activity, that) =>
            that.$t("notification.reservationDeletedPlan", {
                name: that.$_.get(activity, "actorUser.name"),
                title: that.$_.get(activity, "payload.title"),
            }),
    },
    RESERVATION_CREATED: {
        id: "reservation-created",
        icon: "today",
        message: (activity, that) =>
            that.$t("notification.reservationCreated", {
                name: that.$_.get(activity, "payload.userName"),
                visitor: maskActivityVisitorName(that.$_.get(activity, "payload.visitorFullname"), activity),
                date: that.$_.get(activity, "payload.date"),
            }),
    },
    RESERVATION_UPDATED: {
        id: "reservation-updated",
        icon: "event_repeat",
        message: (activity, that) => `Reservation Updated`,
    },
    RESERVATION_DELETED: {
        id: "reservation-deleted",
        icon: "event_busy",
        message: (activity, that) =>
            that.$t("notification.reservationDeleted", {
                name: that.$_.get(activity, "payload.userName"),
                visitor: maskActivityVisitorName(
                    that.$_.get(activity, "payload.visitorFullname") || that.$_.get(activity, "payload.visitorName"),
                    activity
                ),
                date: that.$_.get(activity, "payload.date"),
            }),
    },

    WHITE_LIST_ADDED: {
        id: "white-list-added",
        icon: "today",
        message: (activity, that) =>
            `${_.get(activity, "actorUser.name")} added ${_.get(activity, "payload.ipAddress")} to white list.`,
    },
    WHITE_LIST_REMOVED: {
        id: "white-list-removed",
        icon: "today",
        message: (activity, that) =>
            `${_.get(activity, "actorUser.name")} removed ${_.get(activity, "payload.ipAddress")} from white list.`,
    },
    CUSTOM: {
        id: "custom",
        icon: "message",
        message: (activity) => `${_.get(activity, "payload.message")}`,
        onClick: (activity, that) => {
            const actions = _.get(activity, "payload.actions", []);
            if (actions && actions.length > 0) {
                const executeActionsWithDelay = async () => {
                    for (let i = 0; i < actions.length; i++) {
                        that.executeAction(actions[i]);
                        if (i < actions.length - 1) {
                            await new Promise(resolve => setTimeout(resolve, 2000));
                        }
                    }
                };
                executeActionsWithDelay();
            }
        },
    },
    AUTO_REBALANCE_SUCCESS: {
        id: "auto-rebalance-success",
        icon: "account_balance_wallet",
        message: (activity) => `Otomatik bakiye yüklemesi tamamlandı - ${_.get(activity, "payload.rechargeAmount", 0).toFixed(2)} TL yüklendi`,
    },
    AUTO_REBALANCE_FAILED: {
        id: "auto-rebalance-failed",
        icon: "error_outline",
        message: (activity) => `Otomatik bakiye yüklemesi başarısız oldu (${_.get(activity, "payload.failedAttempts", 0)}/${_.get(activity, "payload.maxFailedAttempts", 3)})`,
    },
    AUTO_REBALANCE_DISABLED: {
        id: "auto-rebalance-disabled",
        icon: "block",
        message: (activity) => `Otomatik bakiye yüklemesi devre dışı bırakıldı - çok fazla başarısız deneme`,
    },
    AUTOMATION_CREATED: {
        id: "automation-created",
        icon: "rocket_launch",
        message: (activity, that) =>
            that.$t("notification.automationCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                automation: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/automations");
        },
    },
    AUTOMATION_DELETED: {
        id: "automation-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.automationDeleted", {
                user: that.$_.get(activity, "actorUser.name"),
                automation: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/automations");
        },
    },
    AUTOMATION_RESTORED: {
        id: "automation-restored",
        icon: "restore",
        message: (activity, that) =>
            that.$t("notification.automationRestored", {
                user: that.$_.get(activity, "actorUser.name"),
                automation: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/automations");
        },
    },
    AUTOMATION_PUBLISHED: {
        id: "automation-published",
        icon: "publish",
        message: (activity, that) =>
            that.$t("notification.automationPublished", {
                user: that.$_.get(activity, "actorUser.name"),
                automation: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/automations");
        },
    },
    AUTOMATION_UNPUBLISHED: {
        id: "automation-unpublished",
        icon: "unpublished",
        message: (activity, that) =>
            that.$t("notification.automationUnpublished", {
                user: that.$_.get(activity, "actorUser.name"),
                automation: that.$_.get(activity, "payload.name"),
            }),
        onClick: (activity, that) => {
            that.$router.push("/automations");
        },
    },
    AUTOMATION_UPDATED: {
        id: "automation-updated",
        icon: "edit",
        message: (activity, that) => {
            var user = that.$_.get(activity, "actorUser.name");
            var automation = that.$_.get(activity, "payload.name");
            var updatedFields = that.$_.get(activity, "payload.updatedFields", {});
            var parts = [];

            if (updatedFields.diagram) {
                var added = that.$_.get(updatedFields, "diagram.addedBlocks", []);
                var removed = that.$_.get(updatedFields, "diagram.removedBlocks", []);
                var updated = that.$_.get(updatedFields, "diagram.updatedBlocks", []);

                if (added.length > 0) {
                    var addedNames = added.map(function(b) { return b.name || b.id; }).join(", ");
                    parts.push(that.$t("notification.automationBlocksAdded", { blocks: addedNames }));
                }
                if (removed.length > 0) {
                    var removedNames = removed.map(function(b) { return b.name || b.id; }).join(", ");
                    parts.push(that.$t("notification.automationBlocksRemoved", { blocks: removedNames }));
                }
                if (updated.length > 0) {
                    var updatedNames = updated.map(function(b) { return b.name || b.id; }).join(", ");
                    parts.push(that.$t("notification.automationBlocksUpdated", { blocks: updatedNames }));
                }
                if (added.length === 0 && removed.length === 0 && updated.length === 0) {
                    parts.push(that.$t("notification.automationDiagramUpdated"));
                }
            }

            if (updatedFields.name !== undefined) {
                parts.push(that.$t("notification.automationNameUpdated"));
            }

            var otherFields = Object.keys(updatedFields).filter(function(k) { return k !== "diagram" && k !== "name"; });
            otherFields.forEach(function(field) {
                parts.push(that.$t("notification.automationFieldUpdated", { field: field }));
            });

            if (parts.length === 0) {
                return that.$t("notification.automationUpdated", { user: user, automation: automation });
            }

            return that.$t("notification.automationUpdatedDetail", { user: user, automation: automation, details: parts.join("; ") });
        },
        onClick: (activity, that) => {
            that.$router.push("/automations");
        },
    },
    FORM_CREATED: {
        id: "form-created",
        icon: "add_box",
        message: (activity, that) =>
            that.$t("notification.formCreated", {
                user: that.$_.get(activity, "actorUser.name"),
                formName: that.$_.get(activity, "payload.formName")
            }),
        onClick: (activity, that) => {
            that.$router.push("/forms");
        }
    },
    FORM_UPDATED: {
        id: "form-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.formUpdated", {
                user: that.$_.get(activity, "actorUser.name"),
                formName: that.$_.get(activity, "payload.formName")
            }),
        onClick: (activity, that) => {
            that.$router.push("/forms");
        }
    },
    FORM_DELETED: {
        id: "form-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.formDeleted", {
                user: that.$_.get(activity, "actorUser.name"),
                formName: that.$_.get(activity, "payload.formName"),
                formId: that.$_.get(activity, "payload.formId")
            }),
        onClick: (activity, that) => {
            that.$router.push("/forms");
        }
    },
    FORM_RESTORED: {
        id: "form-restored",
        icon: "restore",
        message: (activity, that) =>
            that.$t("notification.formRestored", {
                user: that.$_.get(activity, "actorUser.name"),
                formName: that.$_.get(activity, "payload.formName"),
                formId: that.$_.get(activity, "payload.formId")
            }),
        onClick: (activity, that) => {
            that.$router.push("/forms");
        }
    },
    FORM_DOWNLOADED: {
        id: "form-downloaded",
        icon: "download",
        message: (activity, that) =>
            that.$t("notification.formDownloaded", {
                user: that.$_.get(activity, "actorUser.name"),
                formName: that.$_.get(activity, "payload.formName"),
                formId: that.$_.get(activity, "payload.formId")
            }),
        onClick: (activity, that) => {
            that.$router.push("/forms");
        }
    },
    USER_ROLE_CHANGED: {
        id: "user-role-changed",
        icon: "admin_panel_settings",
        message: (activity, that) =>
            that.$t("notification.userRoleChanged", {
                actor: that.$_.get(activity, "actorUser.name"),
                userName: that.$_.get(activity, "payload.userName"),
                oldRoleName: that.$_.get(activity, "payload.oldRoleName"),
                newRoleName: that.$_.get(activity, "payload.newRoleName")
            }),
        onClick: (activity, that) => {
            const userId = that.$_.get(activity, "payload.userId");
            if (userId) {
                that.$router.push(`/settings/users/${userId}`);
            }
        }
    },
    USER_PASSWORD_CHANGED: {
        id: "user-password-changed",
        icon: "lock_reset",
        message: (activity, that) =>
            that.$t("notification.userPasswordChanged", {
                actor: that.$_.get(activity, "actorUser.name"),
                userName: that.$_.get(activity, "payload.userName")
            }),
        onClick: (activity, that) => {
            const userId = that.$_.get(activity, "payload.userId");
            if (userId) {
                that.$router.push(`/settings/users/${userId}`);
            }
        }
    },
    USER_EMAIL_CHANGED: {
        id: "user-email-changed",
        icon: "email",
        message: (activity, that) =>
            that.$t("notification.userEmailChanged", {
                actor: that.$_.get(activity, "actorUser.name"),
                userName: that.$_.get(activity, "payload.userName"),
                oldEmail: that.$_.get(activity, "payload.oldEmail"),
                newEmail: that.$_.get(activity, "payload.newEmail")
            }),
        onClick: (activity, that) => {
            const userId = that.$_.get(activity, "payload.userId");
            if (userId) {
                that.$router.push(`/settings/users/${userId}`);
            }
        }
    },
    USER_NAME_CHANGED: {
        id: "user-name-changed",
        icon: "badge",
        message: (activity, that) =>
            that.$t("notification.userNameChanged", {
                actor: that.$_.get(activity, "actorUser.name"),
                userName: that.$_.get(activity, "payload.userName"),
                oldName: that.$_.get(activity, "payload.oldName"),
                newName: that.$_.get(activity, "payload.newName")
            }),
        onClick: (activity, that) => {
            const userId = that.$_.get(activity, "payload.userId");
            if (userId) {
                that.$router.push(`/settings/users/${userId}`);
            }
        }
    },
    USER_PHONE_CHANGED: {
        id: "user-phone-changed",
        icon: "phone",
        message: (activity, that) =>
            that.$t("notification.userPhoneChanged", {
                actor: that.$_.get(activity, "actorUser.name"),
                userName: that.$_.get(activity, "payload.userName"),
                oldPhone: that.$_.get(activity, "payload.oldPhone"),
                newPhone: that.$_.get(activity, "payload.newPhone")
            }),
        onClick: (activity, that) => {
            const userId = that.$_.get(activity, "payload.userId");
            if (userId) {
                that.$router.push(`/settings/users/${userId}`);
            }
        }
    },
    USER_DISABLED: {
        id: "user-disabled",
        icon: "block",
        message: (activity, that) => {
            const isDisabled = that.$_.get(activity, "payload.isDisabled");
            if (isDisabled) {
                return that.$t("notification.userDisabled", {
                    actor: that.$_.get(activity, "actorUser.name"),
                    userName: that.$_.get(activity, "payload.userName")
                });
            } else {
                return that.$t("notification.userEnabled", {
                    actor: that.$_.get(activity, "actorUser.name"),
                    userName: that.$_.get(activity, "payload.userName")
                });
            }
        },
        onClick: (activity, that) => {
            const userId = that.$_.get(activity, "payload.userId");
            if (userId) {
                that.$router.push(`/settings/users/${userId}`);
            }
        }
    },
    ROLE_UPDATED: {
        id: "role-updated",
        icon: "manage_accounts",
        message: (activity, that) =>
            that.$t("notification.roleUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                roleName: that.$_.get(activity, "payload.roleName")
            }),
        onClick: (activity, that) => {
            const roleId = that.$_.get(activity, "payload.roleId");
            if (roleId) {
                that.$router.push(`/settings/roles`);
            }
        }
    },
    TASK_WORKFLOW_UPDATED: {
        id: "task-workflow-updated",
        icon: "account_tree",
        message: (activity, that) =>
            that.$t("notification.taskWorkflowUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/tasks`);
            }
        }
    },
    TASK_WORKFLOW_PIPELINE_STAGE_ADDED: {
        id: "task-workflow-pipeline-stage-added",
        icon: "add_box",
        message: (activity, that) =>
            that.$t("notification.taskWorkflowPipelineStageAdded", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle"),
                stageName: that.$_.get(activity, "payload.stageName")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/tasks`);
            }
        }
    },
    TASK_WORKFLOW_PIPELINE_STAGE_UPDATED: {
        id: "task-workflow-pipeline-stage-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.taskWorkflowPipelineStageUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle"),
                stageName: that.$_.get(activity, "payload.stageName")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/tasks`);
            }
        }
    },
    TASK_WORKFLOW_PIPELINE_STAGE_DELETED: {
        id: "task-workflow-pipeline-stage-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.taskWorkflowPipelineStageDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle"),
                stageName: that.$_.get(activity, "payload.stageName")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/tasks`);
            }
        }
    },
    DRIVE_FOLDER_CREATED: {
        id: "drive-folder-created",
        icon: "create_new_folder",
        message: (activity, that) =>
            that.$t("notification.driveFolderCreated", {
                actor: that.$_.get(activity, "actorUser.name"),
                folderName: that.$_.get(activity, "payload.folderName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/drive`);
        }
    },
    DRIVE_FOLDER_DELETED: {
        id: "drive-folder-deleted",
        icon: "folder_delete",
        message: (activity, that) =>
            that.$t("notification.driveFolderDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                folderName: that.$_.get(activity, "payload.folderName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/drive`);
        }
    },
    DRIVE_FOLDER_RENAMED: {
        id: "drive-folder-renamed",
        icon: "drive_file_rename_outline",
        message: (activity, that) =>
            that.$t("notification.driveFolderRenamed", {
                actor: that.$_.get(activity, "actorUser.name"),
                oldName: that.$_.get(activity, "payload.oldName"),
                newName: that.$_.get(activity, "payload.newName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/drive`);
        }
    },
    DRIVE_FILE_ADDED: {
        id: "drive-file-added",
        icon: "note_add",
        message: (activity, that) =>
            that.$t("notification.driveFileAdded", {
                actor: that.$_.get(activity, "actorUser.name"),
                fileName: that.$_.get(activity, "payload.fileName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/drive`);
        }
    },
    DRIVE_FILE_DELETED: {
        id: "drive-file-deleted",
        icon: "delete_outline",
        message: (activity, that) =>
            that.$t("notification.driveFileDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                fileName: that.$_.get(activity, "payload.fileName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/drive`);
        }
    },
    TASK_MODULE_RULES_ENABLED: {
        id: "task-module-rules-enabled",
        icon: "rule",
        message: (activity, that) =>
            that.$t("notification.taskModuleRulesEnabled", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/tasks?workflow=${workflowId}`);
            } else {
                that.$router.push(`/tasks`);
            }
        }
    },
    TASK_MODULE_RULES_DISABLED: {
        id: "task-module-rules-disabled",
        icon: "rule",
        message: (activity, that) =>
            that.$t("notification.taskModuleRulesDisabled", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/tasks?workflow=${workflowId}`);
            } else {
                that.$router.push(`/tasks`);
            }
        }
    },
    TASK_MODULE_RULES_RULE_ADDED: {
        id: "task-module-rules-rule-added",
        icon: "add_circle",
        message: (activity, that) =>
            that.$t("notification.taskModuleRulesRuleAdded", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/settings/task-module-rules?workflow=${workflowId}`);
            } else {
                that.$router.push(`/settings/task-module-rules`);
            }
        }
    },
    TASK_MODULE_RULES_RULE_DELETED: {
        id: "task-module-rules-rule-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.taskModuleRulesRuleDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/settings/task-module-rules?workflow=${workflowId}`);
            } else {
                that.$router.push(`/settings/task-module-rules`);
            }
        }
    },
    TASK_MODULE_RULES_RULE_UPDATED: {
        id: "task-module-rules-rule-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.taskModuleRulesRuleUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/settings/task-module-rules?workflow=${workflowId}`);
            } else {
                that.$router.push(`/settings/task-module-rules`);
            }
        }
    },
    TASK_MODULE_RULES_RULE_ENABLED: {
        id: "task-module-rules-rule-enabled",
        icon: "check_circle",
        message: (activity, that) =>
            that.$t("notification.taskModuleRulesRuleEnabled", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/settings/task-module-rules?workflow=${workflowId}`);
            } else {
                that.$router.push(`/settings/task-module-rules`);
            }
        }
    },
    TASK_MODULE_RULES_RULE_DISABLED: {
        id: "task-module-rules-rule-disabled",
        icon: "cancel",
        message: (activity, that) =>
            that.$t("notification.taskModuleRulesRuleDisabled", {
                actor: that.$_.get(activity, "actorUser.name"),
                workflowTitle: that.$_.get(activity, "payload.workflowTitle"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            const workflowId = that.$_.get(activity, "payload.workflowId");
            if (workflowId) {
                that.$router.push(`/settings/task-module-rules?workflow=${workflowId}`);
            } else {
                that.$router.push(`/settings/task-module-rules`);
            }
        }
    },
    CONTACT_MODULE_RULES_ENABLED: {
        id: "contact-module-rules-enabled",
        icon: "check_circle",
        message: (activity, that) =>
            that.$t("notification.contactModuleRulesEnabled", {
                actor: that.$_.get(activity, "actorUser.name")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/contact-module-rules`);
        }
    },
    CONTACT_MODULE_RULES_DISABLED: {
        id: "contact-module-rules-disabled",
        icon: "cancel",
        message: (activity, that) =>
            that.$t("notification.contactModuleRulesDisabled", {
                actor: that.$_.get(activity, "actorUser.name")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/contact-module-rules`);
        }
    },
    CONTACT_MODULE_RULES_RULE_ADDED: {
        id: "contact-module-rules-rule-added",
        icon: "add_circle",
        message: (activity, that) =>
            that.$t("notification.contactModuleRulesRuleAdded", {
                actor: that.$_.get(activity, "actorUser.name"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/contact-module-rules`);
        }
    },
    CONTACT_MODULE_RULES_RULE_UPDATED: {
        id: "contact-module-rules-rule-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.contactModuleRulesRuleUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/contact-module-rules`);
        }
    },
    CONTACT_MODULE_RULES_RULE_DELETED: {
        id: "contact-module-rules-rule-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.contactModuleRulesRuleDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/contact-module-rules`);
        }
    },
    CONTACT_MODULE_RULES_RULE_ENABLED: {
        id: "contact-module-rules-rule-enabled",
        icon: "check_circle",
        message: (activity, that) =>
            that.$t("notification.contactModuleRulesRuleEnabled", {
                actor: that.$_.get(activity, "actorUser.name"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/contact-module-rules`);
        }
    },
    CONTACT_MODULE_RULES_RULE_DISABLED: {
        id: "contact-module-rules-rule-disabled",
        icon: "cancel",
        message: (activity, that) =>
            that.$t("notification.contactModuleRulesRuleDisabled", {
                actor: that.$_.get(activity, "actorUser.name"),
                ruleName: that.$_.get(activity, "payload.ruleName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/contact-module-rules`);
        }
    },
    DEVELOPER_TOKEN_CHANGED: {
        id: "developer-token-changed",
        icon: "vpn_key",
        message: (activity, that) =>
            that.$t("notification.developerTokenChanged", {
                actor: that.$_.get(activity, "actorUser.name")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/developer`);
        }
    },
    TABLE_CREATED: {
        id: "table-created",
        icon: "table_chart",
        message: (activity, that) =>
            that.$t("notification.tableCreated", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_DELETED: {
        id: "table-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.tableDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.name")
            }),
        onClick: (activity, that) => {
            that.$router.push("/tables");
        }
    },
    TABLE_RESTORED: {
        id: "table-restored",
        icon: "restore",
        message: (activity, that) =>
            that.$t("notification.tableRestored", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.name")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_PERMANENTLY_DELETED: {
        id: "table-permanently-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.tablePermanentlyDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.name")
            }),
        onClick: (activity, that) => {
            that.$router.push("/tables");
        }
    },
    TABLE_FIELD_ADDED: {
        id: "table-field-added",
        icon: "add_box",
        message: (activity, that) =>
            that.$t("notification.tableFieldAdded", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                fieldName: that.$_.get(activity, "payload.fieldName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_FIELD_UPDATED: {
        id: "table-field-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.tableFieldUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                fieldName: that.$_.get(activity, "payload.fieldName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_FIELD_DELETED: {
        id: "table-field-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.tableFieldDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                fieldName: that.$_.get(activity, "payload.fieldName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_VIEW_ADDED: {
        id: "table-view-added",
        icon: "visibility",
        message: (activity, that) =>
            that.$t("notification.tableViewAdded", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                viewName: that.$_.get(activity, "payload.viewName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_VIEW_UPDATED: {
        id: "table-view-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.tableViewUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                viewName: that.$_.get(activity, "payload.viewName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_VIEW_DELETED: {
        id: "table-view-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.tableViewDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                viewName: that.$_.get(activity, "payload.viewName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_PAGE_ADDED: {
        id: "table-page-added",
        icon: "note_add",
        message: (activity, that) =>
            that.$t("notification.tablePageAdded", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                pageName: that.$_.get(activity, "payload.pageName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_PAGE_UPDATED: {
        id: "table-page-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.tablePageUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                pageName: that.$_.get(activity, "payload.pageName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_PAGE_DELETED: {
        id: "table-page-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.tablePageDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                pageName: that.$_.get(activity, "payload.pageName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_WIDGET_ADDED: {
        id: "table-widget-added",
        icon: "widgets",
        message: (activity, that) =>
            that.$t("notification.tableWidgetAdded", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                pageName: that.$_.get(activity, "payload.pageName"),
                widgetTitle: that.$_.get(activity, "payload.widgetTitle"),
                widgetType: that.$_.get(activity, "payload.widgetType")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            const pageId = that.$_.get(activity, "payload.pageId");
            if (tableId && pageId) {
                that.$router.push(`/table/${tableId}/page/${pageId}`);
            }
        }
    },
    TABLE_WIDGET_UPDATED: {
        id: "table-widget-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.tableWidgetUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                pageName: that.$_.get(activity, "payload.pageName"),
                widgetTitle: that.$_.get(activity, "payload.widgetTitle"),
                widgetType: that.$_.get(activity, "payload.widgetType")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            const pageId = that.$_.get(activity, "payload.pageId");
            if (tableId && pageId) {
                that.$router.push(`/table/${tableId}/page/${pageId}`);
            }
        }
    },
    TABLE_WIDGET_DELETED: {
        id: "table-widget-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.tableWidgetDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                pageName: that.$_.get(activity, "payload.pageName"),
                widgetTitle: that.$_.get(activity, "payload.widgetTitle"),
                widgetType: that.$_.get(activity, "payload.widgetType")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            const pageId = that.$_.get(activity, "payload.pageId");
            if (tableId && pageId) {
                that.$router.push(`/table/${tableId}/page/${pageId}`);
            }
        }
    },
    TABLE_PERMISSION_CHANGED: {
        id: "table-privacy-changed",
        icon: "lock",
        message: (activity, that) =>
            that.$t("notification.tablePermissionChanged", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_DATA_DOWNLOADED: {
        id: "table-data-downloaded",
        icon: "download",
        message: (activity, that) =>
            that.$t("notification.tableDataDownloaded", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                recordCount: that.$_.get(activity, "payload.recordCount", 0)
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_DATA_IMPORTED: {
        id: "table-data-imported",
        icon: "cloud_upload",
        message: (activity, that) =>
            that.$t("notification.tableDataImported", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                successCount: that.$_.get(activity, "payload.successCount", 0),
                recordCount: that.$_.get(activity, "payload.recordCount", 0)
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_DATA_BATCH_UPDATED: {
        id: "table-data-batch-updated",
        icon: "update",
        message: (activity, that) =>
            that.$t("notification.tableDataBatchUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                recordCount: that.$_.get(activity, "payload.recordCount", 0),
                fieldName: that.$_.get(activity, "payload.fieldName")
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    TABLE_DATA_BATCH_DELETED: {
        id: "table-data-batch-deleted",
        icon: "delete_sweep",
        message: (activity, that) =>
            that.$t("notification.tableDataBatchDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                tableName: that.$_.get(activity, "payload.tableName"),
                recordCount: that.$_.get(activity, "payload.recordCount", 0)
            }),
        onClick: (activity, that) => {
            const tableId = that.$_.get(activity, "payload.tableId");
            if (tableId) {
                that.$router.push(`/table/${tableId}`);
            }
        }
    },
    CONTACT_DATA_DOWNLOADED: {
        id: "contact-data-downloaded",
        icon: "download",
        message: (activity, that) =>
            that.$t("notification.contactDataDownloaded", {
                actor: that.$_.get(activity, "actorUser.name"),
                contactCount: that.$_.get(activity, "payload.contactCount", 0)
            }),
        onClick: (activity, that) => {
            that.$router.push(`/contacts`);
        }
    },
    CONTACT_BATCH_UPDATED: {
        id: "contact-batch-updated",
        icon: "group",
        message: (activity, that) => {
            const action = that.$_.get(activity, "payload.action");
            const actionText = getContactBatchActionText(action);
            return that.$t("notification.contactBatchUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                contactCount: that.$_.get(activity, "payload.contactCount", 0),
                action: actionText
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/contacts`);
        }
    },
    CHAT_DATA_DOWNLOADED: {
        id: "chat-data-downloaded",
        icon: "download",
        message: (activity, that) => {
            const visitorName = that.$_.get(activity, "payload.visitorName");
            const chatCount = that.$_.get(activity, "payload.chatCount", 0);
            if (visitorName) {
                return that.$t("notification.chatDataDownloadedWithVisitor", {
                    actor: that.$_.get(activity, "actorUser.name"),
                    visitorName: maskVisitorDisplayNameIfNeeded(visitorName, _.get(activity, "refVisitor"))
                });
            }
            return that.$t("notification.chatDataDownloaded", {
                actor: that.$_.get(activity, "actorUser.name"),
                chatCount: chatCount
            });
        },
        onClick: (activity, that) => {
            // Chat history sayfasına yönlendir
            that.$router.push(`/visitor-history`);
        }
    },
    WEB_APP_CREATED: {
        id: "web-app-created",
        icon: "web",
        message: (activity, that) =>
            that.$t("notification.webAppCreated", {
                actor: that.$_.get(activity, "actorUser.name"),
                appName: that.$_.get(activity, "payload.appName"),
                appSlug: that.$_.get(activity, "payload.appSlug")
            }),
        onClick: (activity, that) => {
            const appId = that.$_.get(activity, "payload.appId");
            if (appId) {
                that.$router.push(`/web-apps/${appId}`);
            }
        }
    },
    WEB_APP_UPDATED: {
        id: "web-app-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.webAppUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                appName: that.$_.get(activity, "payload.appName"),
                appSlug: that.$_.get(activity, "payload.appSlug")
            }),
        onClick: (activity, that) => {
            const appId = that.$_.get(activity, "payload.appId");
            if (appId) {
                that.$router.push(`/web-apps/${appId}`);
            }
        }
    },
    WEB_APP_DELETED: {
        id: "web-app-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.webAppDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                appName: that.$_.get(activity, "payload.appName"),
                appSlug: that.$_.get(activity, "payload.appSlug")
            }),
        onClick: (activity, that) => {
            // Silinen app için web-apps listesine yönlendir
            that.$router.push(`/web-apps`);
        }
    },
    WEB_TAB_CREATED: {
        id: "web-tab-created",
        icon: "tab",
        message: (activity, that) => {
            const tabPlacement = that.$_.get(activity, "payload.tabPlacement");
            const placementText = tabPlacement === "menu" ? "menüye" : tabPlacement === "toolbar" ? "araç çubuğuna" : "";
            return that.$t("notification.webTabCreated", {
                actor: that.$_.get(activity, "actorUser.name"),
                tabName: that.$_.get(activity, "payload.tabName"),
                placement: placementText
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/settings/web-tabs`);
        }
    },
    WEB_TAB_UPDATED: {
        id: "web-tab-updated",
        icon: "edit",
        message: (activity, that) =>
            that.$t("notification.webTabUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                tabName: that.$_.get(activity, "payload.tabName")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/web-tabs`);
        }
    },
    WEB_TAB_DELETED: {
        id: "web-tab-deleted",
        icon: "delete",
        message: (activity, that) =>
            that.$t("notification.webTabDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                tabName: that.$_.get(activity, "payload.tabName"),
                placement: that.$_.get(activity, "payload.tabPlacement")
            }),
        onClick: (activity, that) => {
            that.$router.push(`/settings/web-tabs`);
        }
    },
    MODULE_CREATED: {
        id: "module-created",
        icon: "add_box",
        message: (activity, that) => {
            const moduleType = that.$_.get(activity, "payload.type");
            const typeText = moduleType === "module" ? "modülünü" : "ilişkisini";
            return that.$t("notification.moduleCreated", {
                actor: that.$_.get(activity, "actorUser.name"),
                moduleName: that.$_.get(activity, "payload.displayName"),
                moduleType: typeText
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/tables`);
        }
    },
    MODULE_UPDATED: {
        id: "module-updated",
        icon: "edit",
        message: (activity, that) => {
            const moduleType = that.$_.get(activity, "payload.type");
            const typeText = moduleType === "module" ? "modülünü" : "ilişkisini";
            return that.$t("notification.moduleUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                moduleName: that.$_.get(activity, "payload.displayName"),
                moduleType: typeText
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/tables`);
        }
    },
    MODULE_DELETED: {
        id: "module-deleted",
        icon: "delete",
        message: (activity, that) => {
            const moduleType = that.$_.get(activity, "payload.type");
            const typeText = moduleType === "module" ? "modülünü" : "ilişkisini";
            return that.$t("notification.moduleDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                moduleName: that.$_.get(activity, "payload.displayName"),
                moduleType: typeText
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/tables`);
        }
    },
    RELATION_CREATED: {
        id: "relation-created",
        icon: "link",
        message: (activity, that) => {
            return that.$t("notification.relationCreated", {
                actor: that.$_.get(activity, "actorUser.name"),
                relationName: that.$_.get(activity, "payload.displayName")
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/tables`);
        }
    },
    RELATION_UPDATED: {
        id: "relation-updated",
        icon: "edit",
        message: (activity, that) => {
            return that.$t("notification.relationUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                relationName: that.$_.get(activity, "payload.displayName")
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/tables`);
        }
    },
    VOICE_AGENT_CREATED: {
        id: "voice-agent-created",
        icon: "record_voice_over",
        message: (activity, that) => {
            return that.$t("notification.voiceAgentCreated", {
                actor: that.$_.get(activity, "actorUser.name"),
                agentName: that.$_.get(activity, "payload.agentName"),
                agentId: that.$_.get(activity, "payload.agentId")
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/voice-agent`);
        }
    },
    VOICE_AGENT_UPDATED: {
        id: "voice-agent-updated",
        icon: "record_voice_over",
        message: (activity, that) => {
            return that.$t("notification.voiceAgentUpdated", {
                actor: that.$_.get(activity, "actorUser.name"),
                agentName: that.$_.get(activity, "payload.agentName"),
                agentId: that.$_.get(activity, "payload.agentId")
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/voice-agent`);
        }
    },
    VOICE_AGENT_DELETED: {
        id: "voice-agent-deleted",
        icon: "record_voice_over",
        message: (activity, that) => {
            return that.$t("notification.voiceAgentDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                agentName: that.$_.get(activity, "payload.agentName"),
                agentId: that.$_.get(activity, "payload.agentId")
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/voice-agent`);
        }
    },
    VOICE_AGENT_PHONE_NUMBER_INBOUND_AGENT_CHANGED: {
        id: "voice-agent-phone-number-inbound-agent-changed",
        icon: "phone",
        message: (activity, that) => {
            return that.$t("notification.voiceAgentPhoneNumberInboundAgentChanged", {
                actor: that.$_.get(activity, "actorUser.name"),
                phoneNumber: that.$_.get(activity, "payload.phoneNumber"),
                agentName: that.$_.get(activity, "payload.agentName")
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/voice-agent`);
        }
    },
    VOICE_AGENT_PHONE_NUMBER_OUTBOUND_AGENT_CHANGED: {
        id: "voice-agent-phone-number-outbound-agent-changed",
        icon: "phone",
        message: (activity, that) => {
            return that.$t("notification.voiceAgentPhoneNumberOutboundAgentChanged", {
                actor: that.$_.get(activity, "actorUser.name"),
                phoneNumber: that.$_.get(activity, "payload.phoneNumber"),
                agentName: that.$_.get(activity, "payload.agentName")
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/voice-agent`);
        }
    },
    VOICE_AGENT_BATCH_CALL_CREATED: {
        id: "voice-agent-batch-call-created",
        icon: "call",
        message: (activity, that) => {
            return that.$t("notification.voiceAgentBatchCallCreated", {
                actor: that.$_.get(activity, "actorUser.name"),
                batchCallName: that.$_.get(activity, "payload.batchCallName"),
                taskCount: that.$_.get(activity, "payload.taskCount", 0)
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/voice-agent`);
        }
    },
    VOICE_AGENT_KNOWLEDGE_BASE_CREATED: {
        id: "voice-agent-knowledge-base-created",
        icon: "library_books",
        message: (activity, that) => {
            return that.$t("notification.voiceAgentKnowledgeBaseCreated", {
                actor: that.$_.get(activity, "actorUser.name"),
                knowledgeBaseName: that.$_.get(activity, "payload.knowledgeBaseName")
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/voice-agent`);
        }
    },
    VOICE_AGENT_KNOWLEDGE_BASE_DELETED: {
        id: "voice-agent-knowledge-base-deleted",
        icon: "library_books",
        message: (activity, that) => {
            return that.$t("notification.voiceAgentKnowledgeBaseDeleted", {
                actor: that.$_.get(activity, "actorUser.name"),
                knowledgeBaseName: that.$_.get(activity, "payload.knowledgeBaseName")
            });
        },
        onClick: (activity, that) => {
            that.$router.push(`/voice-agent`);
        }
    },
};

export default ActivityTypes;
